import { defineMessages } from 'react-intl';

export const chatThreadListMessages = defineMessages({
  newChat: { id: 'chatThreadList.newChat', defaultMessage: 'New chat' },
  patientSection: {
    id: 'patientAgent.threadPatientSection',
    defaultMessage: 'Patient',
  },
  archive: { id: 'patientAgent.threadArchive', defaultMessage: 'Archive' },
  actions: {
    id: 'patientAgent.threadActions',
    defaultMessage: 'Thread actions',
  },
  rename: { id: 'patientAgent.threadRename', defaultMessage: 'Rename' },
  search: { id: 'patientAgent.threadSearch', defaultMessage: 'Search' },
  otherChats: {
    id: 'patientAgent.threadOtherChats',
    defaultMessage: 'Other chats',
  },
  recordChats: {
    id: 'patientAgent.threadRecordChats',
    defaultMessage: 'Record chats',
  },
  thisReport: {
    id: 'patientAgent.threadThisReport',
    defaultMessage: 'This report',
  },
  thisDocument: {
    id: 'patientAgent.threadThisDocument',
    defaultMessage: 'This document',
  },
  thisConsultation: {
    id: 'patientAgent.threadThisConsultation',
    defaultMessage: 'This consultation',
  },
  nothingFound: {
    id: 'patientAgent.threadNothingFound',
    defaultMessage: 'Nothing found',
  },
  noneYet: {
    id: 'patientAgent.threadNoneYet',
    defaultMessage: 'No chats yet',
  },
  today: { id: 'patientAgent.dateToday', defaultMessage: 'Today' },
  yesterday: {
    id: 'patientAgent.dateYesterday',
    defaultMessage: 'Yesterday',
  },
  loadFailed: {
    id: 'patientAgent.threadLoadFailed',
    defaultMessage: 'Could not load the chat list.',
  },
  archiveFailed: {
    id: 'patientAgent.threadArchiveFailed',
    defaultMessage: 'Could not archive the chat.',
  },
  retry: { id: 'patientAgent.threadRetry', defaultMessage: 'Retry' },
});
